<script>
	export let size = 4;
	import { page } from '$app/stores';
	import { hashCode } from '$lib/utils';

	const logoFonts = [
		'Shadows Into Light Two',
		'Monoton',
		'Bungee Shade',
		'Faster One',
		'Licorice',
		'Oooh Baby',
		'Plaster',
		'Galada',
		'Sonsie One'
	];
	$: i = $page.url.pathname !== '' ? hashCode($page.url.pathname) : new Date().getDate();
	// todo: maybe dont change on navigation
	$: logoFont = logoFonts[i % logoFonts.length];
</script>

<svelte:head>
	<svelte:element this="style">
		{':root {'}
		--logo-font: '{logoFont}'
		{'}'}
	</svelte:element>
</svelte:head>

<span style="--logo-font-size: {size}em" on:click={() => i++}>aLap</span>

<style scoped lang="postcss">
	:root {
		--logo-font: 'Galada', cursive;
	}

	span {
		font-family: var(--logo-font);
		text-shadow: 3px;
		font-size: var(--logo-font-size);
		font-weight: 400;
		font-style: normal;
		user-select: none;
		-webkit-tap-highlight-color: none;
		cursor: pointer;

		&:hover {
			opacity: 0.8;
		}
	}
</style>
